<template>
  <!-- 트래픽을 제외한 나머지 차트 및 기타 정보 -->
  <div class="vld-parent">
    <el-form>
      <el-row>
        <el-col :span="4">
          <div class="modal-section modal-section-list">
            <div class="list-title">
              <ul>
                <li class="control-item">
                  <div class="control-item-top">
                    <p class="title">{{ chgTrafficData.title }}</p>
                  </div>
                  <div class="control-item-con">
                    <div
                      :class="
                        'chart-section ' + setChartColor(chgTrafficData.level)
                      "
                    >
                      <div class="btn-area">
                        <el-button
                          type="save"
                          size="mini"
                          :class="setBadgeColor(chgTrafficData.level)"
                          >{{ chgTrafficData.level }}</el-button
                        >
                      </div>
                    </div>
                    <div class="chart-count">
                      <em class="count">{{ chgTrafficData.count }}</em>
                      <span class="unit">{{ chgTrafficData.unit }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-if="treeArea" :class="'list-tree ' + treeClass" ref='treee'>
              <idc-tree ref="tree" :treeList="treeList" :showCheckbox="false" @node-click="nodeClick"> </idc-tree>
            </div>
          </div>
        </el-col>
        <el-col :span="20">
          <el-row class="graph-default" v-if="infoArea || infoContextArea || areaChartPower || chartPowerContextArea">
            <div class="modal-section modal-section-graph">
              <div class="ly-table">
                <el-form label-width="160px" v-if="infoArea">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item :label="$t('messages.lblCustNameA')">{{ info.custNm }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-if="popType == 'power'" label="분전반명 (회로번호)">
                        {{ info.itemNm }}</el-form-item
                      >
                      <el-form-item v-else label="">{{ info.itemNm }}</el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item :label="$t('messages.lblInquiryTime')">
                        {{ info.searchDate }}</el-form-item
                      >
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <!-- Chart Power -->
              <div class="graph" v-if="areaChartPower">
                <div class="graph-title">{{ $t("messages.titChartWeeklyPower") }}</div>
                <div class="graph-area graph-area-power">
                  <idc-no-data
                    style="margin-top: 40px"
                    v-if="flagNoData"
                    :text="$t('messages.msgNodata2')"
                  />
                </div>
                <div class="graph-list" v-if="chartPowerContextArea"></div>
              </div>
            </div>
          </el-row>
          <el-row class="table-section" v-if="listArea">
            <div class="modal-section modal-section-table">
              <idc-table :height="230" :tableHeader="tableHeader" :tableData="tableData" @clickRow="handleRowClick" />
            </div>
            <div class="modal-section modal-section-content" v-show="listAreaContext">
                <idc-editor
                  ref="editor"
                  :editorHtmlContent="sbstContext"
                  :isWrite="false"
                />
            </div>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </div>
</template>

<script>
import moment from "moment";

import jui from "jui-chart/lib/core.min.js";
import "jui-chart/dist/chart.min.js";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import {
  getDateTime,
  getDateStatistics,
  getDateStatisticsRange,
  getNowDateTime,
  commaFormat,
} from "@/assets/js/common.js";

import IdcTree from "@/components/common/IdcTree.vue";
import IdcTable from "@/components/common/IdcTable.vue";
import IdcEditor from "@/components/common/IdcEditor.vue";
import IdcNoData from "@/components/common/IdcNoData.vue";

export default {
  components: {
    Loading,
    IdcTree,
    IdcTable,
    IdcEditor,
    IdcNoData,
  },
  props: {
    popType: {
      type: String,
      default: ""
    },
    trafficData: {
      type: Object,
      default: () => {},
    },
    modalKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      flagNoData: false,
      isLoading: true,
      // 
      custId: '',
      info: {
        custNm: '',
        itemNm: '',
        itemDesc: '',
        lineSpeed: '',
        searchDate: '',
      },

      // isGraphAfterMount: true,
      complete: true,
      data: [],
      data2: [],
      domainX: [],
      treeList: [],

      tableHeader: [
        {
          prop: "col1",
          label: "NO",
          width: "10",
        },
      ],
      tableData: [],
      customTableHeader: {
        smsEventTableHeader: [
          {
            prop: "eventId",
            label: "Event ID",
            width: 100,
          },
          {
            prop: "colecDt",
            label: "수집일시",
            width: 100,
          },
          {
            prop: "idcCdNm",
            label: "DC",
            width: 100,
          },
          {
            prop: "assetNm",
            label: "자산명",
            width: 100,
          },
          {
            prop: "ipAdr",
            label: "IP",
            width: 100,
          },
          /*
          {
            prop: "assetSttus",
            label: "자산상태",
            width: 100,
          },
          */
          {
            prop: "eventTypeCd",
            label: "이벤트유형",
            width: 100,
          },
          {
            prop: "eventClas",
            label: "이벤트등급",
            width: 100,
          },
          {
            prop: "eventNm",
            label: "이벤트명",
            width: 100,
          },
          /*
          {
            prop: "eventSttus",
            label: "이벤트상태",
            width: 100,
          },
          */
          {
            prop: "eventDt",
            label: "이벤트발생일시",
            width: 100,
          },
        ],
        nmsEventTableHeader: [
          {
            prop: "eventId",
            label: "Event ID",
            width: 100,
          },
          {
            prop: "colecDt",
            label: "수집일시",
            width: 100,
          },
          {
            prop: "idcCdNm",
            label: "DC",
            width: 100,
          },
          {
            prop: "assetNm",
            label: "자산명",
            width: 100,
          },
          {
            prop: "ipAdr",
            label: "IP",
            width: 100,
          },
          /*
          {
            prop: "assetSttus",
            label: "자산상태",
            width: 100,
          },
          */
          {
            prop: "eventTypeCd",
            label: "이벤트유형",
            width: 100,
          },
          {
            prop: "eventClas",
            label: "이벤트등급",
            width: 100,
          },
          {
            prop: "eventNm",
            label: "이벤트명",
            width: 100,
          },
          /*
          {
            prop: "eventSttus",
            label: "이벤트상태",
            width: 100,
          },
          */
          {
            prop: "eventDt",
            label: "이벤트발생일시",
            width: 100,
          },
        ],
        secureServiceTableHeader: [
          {
            prop: "idcNm",
            label: "DC",
            width: 100,
          },
          {
            prop: "svcContNo",
            label: "서비스계약번호",
            width: 100,
          },
          {
            prop: "svcType",
            label: "서비스유형",
            width: 100,
          },
          {
            prop: "ccomNm",
            label: "고객명",
            width: 100,
          },
          {
            prop: "incidtTitle",
            label: "제목",
            width: 200,
          },
        ],
        backupServiceTableHeader: [
          {
            prop: "idcNm",
            label: "DC",
            width: 100,
          },
          {
            prop: "svcContNo",
            label: "서비스계약번호",
            width: 100,
          },
          {
            prop: "svcType",
            label: "서비스유형",
            width: 100,
          },
          {
            prop: "ccomNm",
            label: "고객명",
            width: 100,
          },
          {
            prop: "incidtTitle",
            label: "제목",
            width: 200,
          },
        ],
        ddosAttackTableHeader: [
          {
            prop: "idcNm",
            label: "DC",
            width: 100,
          },
          {
            prop: "svcType",
            label: "서비스유형",
            width: 100,
          },
          {
            prop: "svcContNo",
            label: "서비스계약번호",
            width: 100,
          },
          {
            prop: "ccomNm",
            label: "고객명",
            width: 100,
          },
          {
            prop: "incidtTitle",
            label: "제목",
            width: 200,
          },
        ],
      },

      treeClass: '',
      crrModalKey: '',

      // 영역구분
      treeArea: false,
      infoArea: false,
      infoContextArea: false,
      areaChartPower: false,
      chartPowerContextArea: false,
      listArea: false,
      listAreaContext: false,
      sbstContext: "",

      // ---------------------

      chartPower: null,



      
      //
      selectedNodeId: null,
      selectedNodeIfNo: null,
      
      chgTrafficData: {},
    };
  },
  watch: {
    trafficData(){
      if(this.popType == 'powerlist'){
        this.chgTrafficData = this.trafficData;
        this.getPowerInfo();
      }
    }
  },
  mounted() {
    this.treeList = [];
    this.crrModalKey = this.modalKey;
    this.$store.commit("wflowStore/setModalKey", this.crrModalKey);

    this.$nextTick(async () => {
      this.closeChart();

      this.chgTrafficData = JSON.parse(JSON.stringify(this.trafficData));
      // debugger
      this.$store.dispatch("userInfoStore/getCustLoginCustInfo").then(data => {
        this.custId = data.custId;

        switch(this.popType) {
          case "powerlist":
            this.treeArea = true, this.infoArea = true, this.areaChartPower = true, this.chartPowerContextArea = true;
            this.treeClass = 'list-tree-chart';
            this.getPowerInfo();
            break;
          case "power":
            this.treeArea = true, this.infoArea = true, this.areaChartPower = true, this.chartPowerContextArea = true;
            this.treeClass = 'list-tree-chart';
            this.getPowerInfo();
            break;
          case "smsEvent":
          case "nmsEvent":
          case "securService":
          case "backupService":
          case "ddosAttack":
            this.listArea = true;
            this.getEtcInfo(this.popType);
            break;
        }
      });

    });
  },
  methods: {
    showGraph() {
      if (this.isGraph === true) {
        return "graph-default";
      } else if (this.isGraph === false) {
        return "graph-none";
      } else {
        return "graph-default";
      }
    },

    setChartColor(level) {
      switch (level) {
        case "정상":
          return "border-normal";
        case "다소높음":
          return "border-over";
        case "계약전력 초과":
          return "border-warning";
      }
    },

    setBadgeColor(level) {
      switch (level) {
        case "정상":
          return "badge-normal";
        case "다소높음":
          return "badge-over";
        case "계약전력 초과":
          return "badge-warning";
      }
    },

    closeChart() {
      if (this.chartPower != null) {
        this.chartPower.destory();
        this.chartPower = null;
      }
    },

    async nodeClick(row) {
      this.isLoading = true;
      this.flagNoData = false;

      switch(this.popType) {
        case "power":
        case "powerlist":
          if (row.type == 'rack' && row.children.length > 0) {
            this.selectedNodeId = row.id;

            this.tableData.forEach(data => {
              let cbNo = "";
              for (let tmp of row.children) {
                cbNo += tmp.label + ', ';
              }
              cbNo = cbNo.substring(0, cbNo.length - 2);

              if (data.rackAssetNm == row.label) { //  && data.fmsPduId == row.sub
                this.info.custNm     = data.custHnglNm;
                this.info.itemNm     = data.ifPsmNm + ' (' + cbNo + ')';
                this.info.searchDate = getNowDateTime();
              }
            });

            const cbNos = [];
            for (let cbNo of row.children) { cbNos.push(cbNo.ifPsmNm + "|" + cbNo.ifPduNo); }

            const domain = [0, 1]; // 값의 범위 (최소, 최대)
            const legend = {};
            for (let legendSet of cbNos) {
              let splitData = legendSet.split("|")
              legend[legendSet] = splitData[0] + "(" + splitData[1] + ")";
            }

            let chart2Data = [];
            const data2 = await this.getPower7D(row.label, cbNos, row.idcCd);
            if (this.crrModalKey != this.$store.getters["wflowStore/getModalKey"]) {
              return;
            }

            if (data2.length > 0) {
              this.chgTrafficData.level = data2[0].color;
              let statDates = [];
              if(this.popType == "power"){
                statDates = getDateStatistics(7, false);
                this.chgTrafficData.count = data2[0].sumAvgUseQnt.toFixed(2)
              } else{
                this.chgTrafficData.count = data2[0].sumAvgUseQnt.toFixed(2)
                statDates = getDateStatistics(7, false);
                // 선택일에서 오늘날짜 기준으로 변경
                // statDates = getDateStatisticsRange(this.trafficData.colecDtSt, this.trafficData.colecDtEt)
              }
              // debugger
              for (let date of statDates) {
                chart2Data.push({ colecDt: date });  
              }

              var arrAvg = [];
              for (let cTmp of chart2Data) {
                for (let tmpCbNo of cbNos) {
                  cTmp[tmpCbNo] = 0.00;
                }
              }
              for (let cTmp of chart2Data) {
                for (let tmpData of data2) {
                  if (tmpData.colecDt == cTmp.colecDt) {
                    let tmpKey = tmpData.ifPsmName + '|' + tmpData.ifCbNo;
                    if (cTmp[tmpKey] == 0.00) {
                      cTmp[tmpKey] = tmpData.avgUseQnt;
                      arrAvg.push(tmpData.avgUseQnt);
                    }
                  }
                }
              }

              // console.log(chart2Data)

              domain[1] = Math.floor(Math.max(...arrAvg)) + 1;

              setTimeout(() => {
                this.setChartPower(chart2Data, this.chartCategoryForamtterByDefault, legend, domain, "colecDt", cbNos);
              }, 300);
            }
            else {
              this.flagNoData = true;
            }
          }
          else {
            // TODO 초기
          }
          this.isLoading = false;
          break;
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 전력사용량 관련 함수
    getPowerInfo() {
      if (this.custId == null) return;

      this.treeList = [];
      this.$BIZ_SERVICE.post(this.$API_URLS.Com.getPowerInfo, {
          custId: this.custId
        })
        .then((res) => {
          if (res.data.resData.length > 0) {
            const listData = res.data.resData;
            this.tableData = listData;

            // Tree IDC 구성
            var tmpTree = [];
            for (var tmpData of listData) {
              if (tmpTree.length == 0) {
                tmpTree.push({
                  id: tmpData.idcCd,
                  label: tmpData.idcCdNm,
                  children: [],
                });
              }
              else {
                let flag = false;
                for (let tmp of tmpTree) {
                  if (tmp.id == tmpData.idcCd) flag = true;
                }
                if (!flag) {
                  tmpTree.push({
                    id: tmpData.idcCd,
                    label: tmpData.idcCdNm,
                    children: [],
                  });
                }
              }
            }

            for (var tmpIdc of tmpTree) {
              for (var tmpRack of listData) {
                if (tmpIdc.id == tmpRack.idcCd) {
                  let arrCb = [];
                  let idxList = 0;
                  for (let tmpCb of listData) {
                    idxList++;
                    if (tmpCb.rackSeq == tmpRack.rackSeq) {
                      arrCb.push({
                        id: idxList + '_' + tmpCb.ifPduNo,
                        ifPsmNm: tmpCb.ifPsmNm,
                        ifPduNo: tmpCb.ifPduNo,
                        label: tmpCb.ifPsmNm + ' / ' + tmpCb.ifPduNo,
                        idcCd: tmpRack.idcCd,
                      })
                    }
                  }

                  if (tmpIdc.children.length == 0) {
                    tmpIdc.children.push({
                      id: tmpRack.rackSeq,
                      label: tmpRack.rackAssetNm,
                      type: 'rack',
                      idcCd: tmpRack.idcCd,
                      children: arrCb,
                    });
                  }
                  else {
                    let flag = false;
                    for (let tmp of tmpIdc.children) {
                      if (tmp.id == tmpRack.rackSeq) flag = true;
                    }
                    if (!flag) {
                      tmpIdc.children.push({
                        id: tmpRack.rackSeq,
                        label: tmpRack.rackAssetNm,
                        type: 'rack',
                        idcCd: tmpRack.idcCd,
                        children: arrCb,
                      });
                    }
                  }
                }
              }
            }
            this.treeList = tmpTree;
          }
        })
        .finally(() => {
          if (this.treeList.length > 0) {
            if (this.treeList[0].children.length > 0) {
              this.$refs['tree'].$refs.refTree.setCurrentKey("" + this.treeList[0].children[0].id);
              // debugger
              if(this.popType == 'power'){
                this.nodeClick(this.treeList[0].children[0]);
              } else {
                this.nodeClick(this.treeList[0].children[this.trafficData.index - 1]);

              }
            }
            else {
              this.isLoading = false;
            }
          }
          else {
            this.isLoading = false;
          }
        });
    },

    async getPower7D(itemId, itemId2, idcCd) {
      // debugger
      let isDefault = '';
       switch(this.popType) {
        case "powerlist":
          isDefault = true
          // isDefault = false 선택일 기준에서 오늘날짜 기준으로 변경
          break;
        default:
          isDefault = true
          break;
       }
        const { data } = await this.$BIZ_SERVICE.post(this.$API_URLS.Com.getPower7D, { isDefault: isDefault, itemId: itemId, itemId2: itemId2, idcCd: idcCd, colecDtSt:this.trafficData.colecDtSt, colecDtEt:this.trafficData.colecDtEt });
          if (data.resData.length > 0) {
            return data.resData;
          }
          return [];
    },

    // ----------------------------------------------------------------------------------------------------
    // 기타 관련 함수
    async getEtcInfo(props) {
      let getListApiUrl = "";
      let params = {
        custId: this.custId,
      };
      let customTableHeader = [];

      switch(props) {
        case "smsEvent":
          customTableHeader = this.customTableHeader.smsEventTableHeader;
          getListApiUrl = this.$API_URLS.Com.getSmsEventList;
          break;
        case "nmsEvent":
          customTableHeader = this.customTableHeader.nmsEventTableHeader;
          getListApiUrl = this.$API_URLS.Com.getNmsEventList;
          break;
        case "securService":
          customTableHeader = this.customTableHeader.secureServiceTableHeader;
          getListApiUrl = this.$API_URLS.Com.getSecurServiceList;
          break;
        case "backupService":
          customTableHeader = this.customTableHeader.backupServiceTableHeader;
          getListApiUrl = this.$API_URLS.Com.getBackupServiceList;
          break;
        case "ddosAttack":
          customTableHeader = this.customTableHeader.ddosAttackTableHeader;
          getListApiUrl = this.$API_URLS.Com.getDDosAttackList;
          break;
          
      }

      if (getListApiUrl != "") {
        const listData = await this.getEtcList(getListApiUrl, params);
        this.tableHeader = customTableHeader;
        this.tableData = listData.map(tmpData => {
          if (tmpData.colecDt != null && tmpData.colecDt.length == 12) {
            const tmpColecDt = tmpData.colecDt;
            tmpData.colecDt = tmpColecDt.substring(0,4) + '-' + tmpColecDt.substring(4,6) + '-' + tmpColecDt.substring(6,8)
                         + ' ' + tmpColecDt.substring(8,10) + ':' + tmpColecDt.substring(10,12);
          }
          if (tmpData.eventDt != null && tmpData.eventDt.length == 12) {
            const tmpEventDt = tmpData.eventDt;
            tmpData.eventDt = tmpEventDt.substring(0,4) + '-' + tmpEventDt.substring(4,6) + '-' + tmpEventDt.substring(6,8)
                         + ' ' + tmpEventDt.substring(8,10) + ':' + tmpEventDt.substring(10,12);
          }

          return tmpData;
        });
      }

    },

    async getEtcList(url, params) {
      const { data } = await this.$BIZ_SERVICE.post(url, params);
      if (data.resData.length > 0) {
        return data.resData;
      }
      return [];
    },

    handleRowClick(col, row) {
      if (this.popType == 'securService' || this.popType == 'backupService') {
        this.sbstContext = row.incidtSbst;
        this.listAreaContext = true;
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 차트 관련 함수

    setChartPower(data, categoryFormatter, legend, domain, categolyName, axisNames) {

      // debugger
      if (this.chartPower == null) {
        let chart = jui.include("chart.builder");
        this.chartPower = chart(".graph-area-power", {
          /*
          padding : {
            left : 95
          },
          */
          axis: [
            {
              x: {
                type: "fullblock",
                domain: categolyName,
                line: "soild",
                // textRotate: -25,
                format: categoryFormatter,
              },
              y: {
                type: "range",
                domain: domain,
                line: "solid",
                step: 5,
              },
              data: data,
            },
          ],
          brush: [
            {
              type: "line",
              axis: [0],
              target: axisNames,
              animate: true,
            },
          ],
          widget: [
            {
              type: "legend",
              brush: [0],
              format: function (k) {
                return legend[k];
              },
            },
            /*
            {
              type: "title",
              text: "Bits Per Second",
              align: "start",
              orient: "center",
              dx: -130,
              dy: -20
            }
            */
          ],
          style: {},
        });
      }
      else {
        setTimeout(() => {
          this.chartPower.axis(0).updateGrid("y", {
            type: "range",
            domain: domain,
            line: "solid",
            step: 5,
          });
          this.chartPower.updateBrush(0, {
            type: "line",
            target: axisNames,
            animate: true,
          });
          this.chartPower.updateWidget(0, {
            type: "legend",
            format: function (k) {
              return legend[k];
            },
          });
          this.chartPower.axis(0).update(data);
          this.chartPower.render(true);
        }, 300);
      }
    },

    chartCategoryForamtterByTime(d, cnt) {
      if (cnt%2 == 0) return d.substring(8,10) + ':' + d.substring(10,12) + ':' + d.substring(12,14);
    },

    chartCategoryForamtterByTime2(d, cnt) {
      if (cnt%2 == 0) return d.substring(8,10) + ' 시';
    },

    chartCategoryForamtterByTime3(d, cnt) {
      if (cnt%20 == 0) return d.substring(8,10) + ' 시 ' + d.substring(10,12) + '분';
    },

    chartCategoryForamtterByTime4(d, cnt) {
      if (d.substring(10,12) == '00') return d.substring(8,10);
      // if (cnt%20 == 0) return d.substring(8,10) + ' 시 ' + d.substring(10,12) + '분';
    },

    // 트래픽 주간 Catalog Formatter
    chartCategoryForamtterByTrafficWeekly(d, cnt) {
      if (d.substring(8,10) == '00' && d.substring(10,12) == '00') {
        let week = moment().year(d.substring(0,4)).months(d.substring(4,6)).day(d.substring(6,8)).format('ddd');
        return d.substring(6,8) + ' (' + week + ')';
      }
    },

    chartCategoryForamtterByTrafficMonth(d, cnt) {
      if (d.substring(10,12) == '00') return d.substring(8,10);
      // if (cnt%20 == 0) return d.substring(8,10) + ' 시 ' + d.substring(10,12) + '분';
    },

    chartCategoryForamtterByYmd(d, cnt) {
      return d.substring(0,4) + '-' + d.substring(4,6) + '-' + d.substring(6,8);
    },

    chartCategoryForamtterByDay(d, cnt) {
      return d.substring(6,8);
    },

    chartCategoryForamtterByDefault(d, cnt) {
      return d;
    },
  },
};
</script>

<style lang="scss" scoped>
.graph {
  &-default {
    // display: block;
  }
  &-none {
    .el-row {
      padding: 0;
    }
    & + .table-section {
      .modal-section-table {
        margin-top: -20px;
        height: 1200px;
      }
      .modal-section-content {
        margin-top: -20px;
        height: 1200px;
      }
    }
  }
}
.ly {
  &-no-data {
    height: 380px;
  }
}
.modal-section {
  box-sizing: border-box;
  border: 1px solid $--border-color-gray;
  border-radius: $--border-radius-base;
  &-list {
    // height: 1200px; //좌측 트리
    margin-right: 20px;
    .list-title {
      padding-top: 10px;
      height: 240px;
      border-bottom: 1px solid $--border-color-gray;
    }
    .list-tree {
      min-height: 269px;
      height: 1200px; //차트 차트 테이블
      &-chart{
        height: 269px;  // 차트
        &-table{
          height: 730px;
        }
        &2{
          height: 855px; // 차트 차트
        }
      }
      &-table{ // 테이블
        height: 269px;
      }
      text-align: left;
      margin-top: 20px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        &-thumb {
          width: 3px;
          height: 3px;
          background-color: $--text-disabled;
          border-radius: $--border-radius-base;
        }
      }
    }
  }
  &-graph {
    text-align: left;
    padding: 0 20px;
    // height: 850px; // 우측 데이터
    // overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      &-thumb {
        width: 3px;
        height: 3px;
        background-color: $--text-disabled;
        border-radius: $--border-radius-base;
      }
    }
    .description-list {
      li {
        display: list-item;
        list-style-type: disc;
        margin: 5px 0 0 25px;
      }
    }
  }
  &-table {
    height: 330px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      &-thumb {
        width: 3px;
        height: 3px;
        background-color: $--text-disabled;
        border-radius: $--border-radius-base;
      }
    }
    border: 0;
  }
}
::v-deep {
  .el-row.table-section {
    padding-bottom: 0;
  }
  .el-form-item__label {
    text-align: left;
  }
  .el-tree-node__expand-icon.is-leaf.icon-CaretDown:before {
    background-color: unset;
  }
}
.graph {
  .graph {
    &-title {
      margin: 20px 0 0 0;
      font-size: $--font-size-medium;
      font-weight: $--font-weight-Medium;
      position: relative;
      z-index: 3;
    }
    &-area {
      height: 380px;
      margin-top: -30px;
    }
    &-list {
      width: 800px;
      height: 50px;
      margin: 0 0 20px 25px;
      ul {
        width: 33%;
        float: left;
      }
      li {
        display: list-item;
        list-style-type: disc;
        margin-top: 5px;
        b {
          color: $--color-primary;
        }
        i {
          color: $--work-flow-pend-background-color;
        }
      }
    }
  }
}
.count {
  color: $--color-point;
  font-weight: $--font-weight-bold;
  position: relative;
  &:after {
    content: "";
    display: inline-block;
    width: 100%;
    height: 1px;
    background-color: $--color-point;
    clear: both;
    position: absolute;
    left: 0;
    bottom: 2px;
  }
}
.control {
  &-item {
    flex: 0 0 25%;
    margin: 0 6px;
    &-top {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      margin-bottom: 15px;
      .title {
        color: $--text-default;
        font: {
          size: $--font-size-large;
          weight: $--font-weight-bold;
        }
      }
    }
    &-con {
      position: relative;
      .chart-count {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: baseline;
        position: absolute;
        left: 50%;
        top: 46%;
        transform: translate(-50%, -50%);
        .count {
          font-size: 1.825rem;
          color: $--text-default;
          &:after {
            height: 1.5px;
            background-color: $--color-black;
          }
        }
        .unit {
          font-size: $--font-size-base;
          color: #5e5e5e;
        }
      }
      ::v-deep {
        .el-button {
          &.el-button--mini {
            min-width: 34px;
            letter-spacing: -0.28px;
            font-size: $--font-size-extra-small;
            border: none;
          }
          &.el-button--save {
            &.badge-normal {
              background-color: $--chart-nomal;
            }
            &.badge-over {
              background-color: $--chart-over;
            }
            &.badge-warning {
              background-color: $--chart-warning;
            }
          }
        }
      }
      .chart-section {
        height: 160px;
        width: 160px;
        border: 12px solid;
        border-radius: 50%;
        margin: 0 auto;
        .btn-area {
          position: absolute;
          top: 65%;
          width: 132px;
          text-align: center;
          align-items: center;
          // left: 38%;
        }
      }
      .border-normal {
        border-color: $--chart-nomal;
      }
      .border-over {
        border-color: $--chart-over;
      }
      .border-warning {
        border-color: $--chart-warning;
      }
    }
  }
}
</style>

